import type { CliE2eeRuntime } from '../../../lib/e2ee/index.js';
import { SHORTCUT_CODE_NAV_E2EE_FIELDS } from './code-nav-fields.js';

/** Encrypt code-nav payload when E2EE is active; returns cloud-compatible `{ ee }` body. */
export function encryptShortcutCodeNavBody(
  body: Record<string, unknown>,
  e2ee: CliE2eeRuntime | undefined,
): Record<string, unknown> {
  if (!e2ee) return body;
  const encrypted = e2ee.encryptFields(body, SHORTCUT_CODE_NAV_E2EE_FIELDS);
  if (encrypted.ee != null && typeof encrypted.ee === 'object') {
    return { ee: encrypted.ee };
  }
  return body;
}
